import React, { useRef, useState, useEffect } from "react";
import { Stage, Layer, Image, Rect } from "react-konva";
import apiService from "../../service";
import { useParams } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import PreviewComponent from "../Preview/Preview";

const BankChecquePreview = () => {
  const { id } = useParams();
  const [dataAvailable, setDataAvailable] = useState(null);

  //Aadhar Preview  get api calling here
  useEffect(() => {
    async function fetchData() {
      try {
        const data = await apiService.getbankchequedataById(id);
        setDataAvailable(data);
      } catch (error) {
        console.error(error);
      }
    }

    fetchData();
  }, []);

  const breadCrumbArray = [
    {
      name: "Bank Cheque",
      color: "#000000",
      underline: "none",
      href: "/doc-ai/bank-cheque",
    },
    {
      name: dataAvailable?.file_name,
      color: "#767676",
      underline: "none",
    },
  ];

  return (
    <>
      <PreviewComponent
        dataAvailable={dataAvailable}
        setDataAvailable={setDataAvailable}
        breadCrumbNames={breadCrumbArray}
        id={id}
      />
    </>
  );
};

export default BankChecquePreview;
